import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/paises/paises';
import CrearEditar from './CrearEditar';

const ms2p = (state) => {
  return {
    ...state.paises,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearEditar);
